<template>
  <VCardText class="h-100" :class="isConfirmationPage ? 'p-0' : ''">
    <VRow class="d-flex flex-column h-100 flex-nowrap">
      <VCol v-if="!isConfirmationPage">
        <div style="width: 100%; height: 285px">
          <RideMap :getStopsList="getStopsList"/>
        </div>
      </VCol>
      <VCol v-if="!isConfirmationPage"
            class="search-result__total-price d-flex justify-space-between textPrimary--text">
        <span class="heading-6" v-if="isFreeOfChargeTrip">
          {{ $t('bookingForm.freeOfChargeTrip') }}
        </span>
        <template v-else>
          <span class="heading-6 mr-2">{{ $t(totalPriceLabelKey) }}</span>
          <span class="heading-6 text-nowrap">€ {{ totalPrice }}</span>
        </template>
      </VCol>
      <VCol
        :class="{
          'rides': (!isConfirmationPage && !selectedRides.length),
          'checkout-search-result': isCheckoutPage,
          'sm': isCheckoutPage && $vuetify.breakpoint.smOnly,
          'md': isCheckoutPage && $vuetify.breakpoint.mdOnly,
          'lg': isCheckoutPage && $vuetify.breakpoint.lgOnly,
          'xl': isCheckoutPage && $vuetify.breakpoint.xlOnly,
          'pb-0': true,
        }"
      >
        <div
            v-for="(ride, index) in selectedRides"
            :key="`ride_${index}`"
            class="body-2"
        >
          <Ride
              :class="(index + 1) === selectedRides.length ? 'pb-0' : 'pb-6'"
              :ride="ride"
              :index="index"
              :orderAsc="!index"
              :isConfirmationPage="isConfirmationPage"
          />
        </div>
      </VCol>
    </VRow>
  </VCardText>
</template>
<script lang="ts">
export default {
  name: 'SBookingSummary',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import Ride from '@slg/web-customer-shared/src/components/common/ride/Ride.vue';
import RideMap from './RideMap.vue';
import { useRouteRef, useStore } from '../../../composables';

const props = defineProps({
  selectedRides: {
    type: Array,
    default: () => [],
  },
  isConfirmationPage: {
    type: Boolean,
    default: false,
  },
  isCheckoutPage: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const route = useRouteRef();

const getAppConfig = computed(() => store.getters['common/getAppConfig']);

const totalPriceLabelKey = computed(() => {
  if (getAppConfig.value?.isNightCardsSupport && route.value.name === 'Booking') {
    return 'nightRider.priceBeforeNightCardDiscount';
  }
  return 'bookingForm.totalPrice';
});

const getStopsList = computed(() => {
  const stops = (props.selectedRides as Array<Record<string, any>>)
    .map((ride) => {
      const outward = {
        lat: +ride.outward.lat,
        lon: +ride.outward.lon,
      };
      const arrival = {
        lat: +ride.arrival.lat,
        lon: +ride.arrival.lon,
      };
      return [outward, arrival];
    })
    .flat();
  return stops.reduce((accumulator: Array<{ lat: number; lon: number }>, currentValue) => {
    const isDuplicate = accumulator.find((el) => {
      return el.lat === currentValue.lat && el.lon === currentValue.lon;
    });
    if (isDuplicate) {
      return accumulator;
    }
    return accumulator.concat(currentValue);
  }, []);
});

const totalPrice = computed(() => {
  let price = 0;
  (props.selectedRides as Array<{ ridePrice: number }>).forEach((ride) => {
    price += ride.ridePrice;
  });
  return Number(price || 0).toFixed(2);
});

const isFreeOfChargeTrip = computed(() => Number(totalPrice.value) <= 0);
</script>
<style lang="scss" scoped>
.search-result {
  &__map {
    overflow: hidden;
    border-radius: 0.5rem;

    img {
      width: 100%;
    }
  }
}

.checkout-search-result {
  overflow-y: auto;

  &.md {
    min-height: 168px;
  }

  &.sm {
    min-height: 218px;
  }

  &.lg {
    min-height: 164px;
  }

  &.xl {
    min-height: 380px;
  }
}

.rides {
  min-height: calc(100vh - 505px);
}

.image {
  width: 100%;
}
</style>
